export function PlanApercu({ plan }) {
  return (
    <div className="mt-2 text-xs" data-testid="plan-apercu">
      <div className="text-slate-600 mb-1">
        Assigné à <b>{plan.assignee.name || plan.assignee.email}</b> (gestionnaire GE {plan.territoire})
        {plan.date_inspection && <> · inspection le <b>{plan.date_inspection}</b></>} · {plan.taches.length} tâche(s)
      </div>
      <ul className="divide-y divide-slate-100 border border-slate-200 rounded bg-white max-h-64 overflow-y-auto">
        {plan.taches.map((t) => (
          <li key={t.item_id} className="px-2 py-1.5 flex gap-2" data-testid="plan-apercu-tache">
            <span className="font-semibold text-[#8a6d2f] w-20 shrink-0">{t.echeance}</span>
            <span className="flex-1">{t.titre}</span>
            <span className="text-slate-500 shrink-0">{t.etat} · {t.priorite}</span>
          </li>
        ))}
      </ul>
      {plan.deja_planifiees?.length > 0 && <div className="text-slate-500 mt-1">Déjà planifié (ignoré) : {plan.deja_planifiees.join(", ")}</div>}
    </div>
  );
}
